import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleJakZaczac from "../pages/article/jak-zaczac/page";
import ArticleBezpieczenstwo from "../pages/article/bezpieczenstwo-zakupow/page";
import ArticleKategorie from "../pages/article/najlepsze-kategorie/page";
import ArticleWysylka from "../pages/article/wysylka-polska/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/poradnik-kakobuy",
    element: <ArticlePage />,
  },
  {
    path: "/poradnik-kakobuy/jak-zaczac",
    element: <ArticleJakZaczac />,
  },
  {
    path: "/poradnik-kakobuy/bezpieczenstwo-zakupow",
    element: <ArticleBezpieczenstwo />,
  },
  {
    path: "/poradnik-kakobuy/najlepsze-kategorie",
    element: <ArticleKategorie />,
  },
  {
    path: "/poradnik-kakobuy/wysylka-polska",
    element: <ArticleWysylka />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;